import React from "react";
import { useListContext } from "react-admin";
import { TopToolbar } from "react-admin";

import { AsOfDateModeActions } from "./AsOfDateModeActions";
import { CustomerArticlesExportModal } from "./CustomerArticlesExportModal";

export const CustomerArticlesActions = () => {
	const { filterValues } = useListContext();

	return (
		<TopToolbar>
			{!filterValues?.is_as_of_date_mode && (
				<CustomerArticlesExportModal filterValues={filterValues} />
			)}
			<AsOfDateModeActions />
		</TopToolbar>
	);
};
